// extracted by mini-css-extract-plugin
module.exports = {"row":"EnrollClinic_row__2xE2r"};